module.exports = __webpack_public_path__ + "img/crossIcon.d73eaaac.svg";